import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '*',
    //   redirect: '/'
    // }, 
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        // {
        //   path: '/',
        //   redirect: '/home'
        // }, 
        {
          path: '/',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        },  
        {
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/product'], resolve),
          meta: {
            title: title + '-产品展示'
          }
        }, 
        {
          path: '/productDetail/:id',
          name: 'productDetail',
          component: resolve => require(['@/view/productDetail'], resolve),
          meta: {
            title: title + '-产品详情'
          }
        },
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-动态'
          },
          children: [
            {
              path: '/newsinformation/:id',
              name: 'newsinformation',
              component: resolve => require(['@/view/NewsInformation'], resolve),
              meta: {
                title: title + '-新闻动态'
              }
            }
          ]
        }, 
        {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-动态详情'
          }
        }, 
        {
          path: '/companyintroduction-1',
          name: 'companyintroduction-1',
          component: resolve => require(['@/view/CompanyIntroduction-1'], resolve),
          meta: {
            title: title + '走进联创'
          }
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        },
        {
          path: '/companyzz',
          name: 'companyzz',
          component: resolve => require(['@/view/companyzz'], resolve),
          meta: {
            title: title + '-资质荣誉'
          }
        }, 
        {
          path: '/tecRes',
          name: 'tecRes',
          component: resolve => require(['@/view/tecRes'], resolve),
          meta: {
            title: title + '-技术资源'
          }
        }, 
        {
          path: '/case',
          name: 'case',
          component: resolve => require(['@/view/case'], resolve),
          meta: {
            title: title + '-客户案例'
          }
        }, 
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js